module.exports = __webpack_public_path__ + "static/media/SamusAran.8f5c0208.png";